export const colors = {
  primary: "#FC8B23",
  gray100: "#F7F7F7",
};
